import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert








const messageInput = byId('messageInput');
const onClickLinkInput = byId('onClickLinkInput');
const announcementsTableBodyElement = byId('announcementsTableBodyElement');
const announcementsTableNoDataRowElement = byId('announcementsTableNoDataRowElement');
const announcementsDataFun = {
    addNew: {
        submit: async () => {



            try {
                const data = {

                    message: messageInput.value,
                    onClickLink: onClickLinkInput.value,

                };
                const response = await callTheApServerPost(`/basic/addNewAnnouncement`, { data: data });
                axiosResponseHandler(response);
                const res = response.data;






                if (res.status === 'success') {
                    console.log(res);


                    Swal.fire({
                        title: 'New Announcement added',
                        icon: 'success',
                        showConfirmButton: false,


                        allowOutsideClick: false,


                    });

                    setTimeout(() => {
                        location.reload();
                    }, 3000);



                }
            } catch (error) {
                axiosErrorHandler(error);
                console.log(error);
            }
        }
    },
    delete: async ({ sn }) => {


        try {
            const response = await callTheApServerGet(`/basic/deleteAnnouncement/${sn}`);
            axiosResponseHandler(response);
            const res = response.data;

            if (res.status === 'success') {
                console.log(res);


                Swal.fire({
                    title: 'Announcement Deleted',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);



            }
        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }

    },
    get: async () => {


        try {
            const response = await callTheApServerGet(`/basic/getAnnouncements`);
            axiosResponseHandler(response);
            const res = response.data;






            if (res.status === 'success') {
                console.log(res);




                if (res.AnnouncementData.length > 0) {

                    addDNoneClass(announcementsTableNoDataRowElement, true);

                    let i = 0;
                    while (i < res.AnnouncementData.length) {
                        const { sn, message, onClickLink } = res.AnnouncementData[i];

                        announcementsTableBodyElement.innerHTML += `
                        <tr>
                        
                            <td>${i + 1}</td>
                            <td>${message}</td>
                            <td>${onClickLink}</td>
                         
                            <td><button class="btn btn-danger" onclick="announcementsDataFun.delete(${JSON.stringify({ sn }).split('"').join('&quot;')})" >Delete</button></td>
                          
                        </tr>
                        `;
                        i++;
                    }
                } else {
                    announcementsTableNoDataRowElement.innerHTML = `
                    <th class='text-center' colspan='4'>No Announcement Found 😥</th> 
                    `;
                }





            }

        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }
    }
};

window.announcementsDataFun = announcementsDataFun;

announcementsDataFun.get();
